export const baseUrls = {
  home: '/',
  unauthorised: '/unauthorised',
  newKybSubmission: '/kyb-requests/new-kyb-submission',
  signDocument: '/kyb-requests/new-kyb-submission/sign-document',
  kybRequests: '/kyb-requests',
  riskLimitsRequests: '/risk-limits-requests',
  riskLimitsRequest: '/risk-limits-requests/:requestRef',
  manageAccountLimits: '/risk-limits-requests/manage-account-limits',
  manageAccountLimit: '/risk-limits-requests/manage-account-limits/:accountId',
  accountChangeRequests: '/account-change-requests',
  accountChangeRequest: '/account-change-requests/:requestRef',
  marketDataAccess: '/market-data-access',
  cashMovementRequests: '/cash-movement-requests',
  cashMovementRequest: '/cash-movement-requests/:requestRef',
  cashMovementNewRequest: '/cash-movement-requests/new/:paymentType',
  cashMovementNewRequestSubmitted: '/cash-movement-requests/new/submitted/:paymentType',
  cashMovementBulkRequest: '/cash-movement-requests/new-bulk',
  cashMovementBulkSubmitted: '/cash-movement-requests/new-bulk/submitted',
  generalRequests: '/general-requests',
  createGeneralRequest: '/general-requests/new',
  generalRequest: '/general-requests/:requestRef'
} as const;

export type ConciergeUrl = keyof typeof baseUrls;
